import { SignInApp } from "@domain/models/SignInApp";
import { useRouter } from "next/router";

export interface IUseLoginDestinyOut {
  app: SignInApp;
  path?: string;
  params?: { [key: string]: string };
}

export function useLoginDestiny(): IUseLoginDestinyOut | undefined {
  const router = useRouter();
  const app = [router.query['app']].flat()[0];
  const path = [router.query['path']].flat()[0];
  const params = [router.query['params']].flat()[0];
  if (!app) return undefined;
  return {
    app: app as SignInApp,
    path: path ? path : undefined,
    params: Object.fromEntries(new URLSearchParams(params)),
  }
}
